export type PopupAnchor = 'top' | 'bottom' | 'left' | 'right';

export interface PopupPosition {
  anchor: PopupAnchor;
  offset?: [number, number];
}

export interface PopupOffsets {
  leftCornerVertical: number;
  rightTopCornerVertical: number;
  rightBottomCornerVertical: number;
}

export interface CalculatePopupAnchorParams {
  clickCoordinates: { vertical: number; horizontal: number };
  containerSize: { width: number; height: number };
  popupSize?: { width: number; height: number };
  edgeThreshold?: number;
  offsets: PopupOffsets;
}

export const calculatePopupAnchor = ({
  clickCoordinates,
  containerSize,
  popupSize = { width: 600, height: 400 },
  edgeThreshold = 100,
  offsets
}: CalculatePopupAnchorParams): PopupPosition => {
  const isClickNearTopEdge = clickCoordinates.vertical < popupSize.height + edgeThreshold;
  const isClickNearBottomEdge = clickCoordinates.vertical > containerSize.height - popupSize.height - edgeThreshold;
  const isClickNearLeftEdge = clickCoordinates.horizontal < popupSize.width / 2 + edgeThreshold;
  const isClickNearRightEdge = clickCoordinates.horizontal > containerSize.width - popupSize.width - edgeThreshold;

  if (isClickNearLeftEdge && isClickNearTopEdge) return { anchor: 'left', offset: [0, -offsets.leftCornerVertical] };
  if (isClickNearLeftEdge && isClickNearBottomEdge) return { anchor: 'left', offset: [0, offsets.leftCornerVertical] };

  if (isClickNearRightEdge && isClickNearTopEdge) return { anchor: 'right', offset: [0, offsets.rightTopCornerVertical] };
  if (isClickNearRightEdge && isClickNearBottomEdge) return { anchor: 'right', offset: [0, offsets.rightBottomCornerVertical] };

  if (isClickNearLeftEdge) return { anchor: 'left' };
  if (isClickNearRightEdge) return { anchor: 'right' };
  if (isClickNearTopEdge) return { anchor: 'top' };
  if (isClickNearBottomEdge) return { anchor: 'bottom' };

  return { anchor: 'bottom' };
};
